import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import SEOContentSection from "./components/SEOContentSection";
import ArticlePreview from "./components/ArticlePreview";
import CTASection from "./components/CTASection";

const siteUrl = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "pandabuy.help",
  url: siteUrl,
  description: "The #1 Curated Pandabuy Spreadsheet Hub — discover verified Pandabuy finds organized into structured spreadsheets for sneakers, streetwear, accessories and more.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SEOContentSection />
        <ArticlePreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}